export const actions = {
  LOTES_IMPRESION_LOAD_REQUESTED: 'LOTES_IMPRESION_LOAD_REQUESTED',
  LOTES_IMPRESION_LOAD_SUCCEEDED: 'LOTES_IMPRESION_LOAD_SUCCEEDED',
  LOTES_IMPRESION_LOAD_FAILED: 'LOTES_IMPRESION_LOAD_FAILED',
}

export const getLotesImpresionFilteredAction = (dispatch, payload) => {
  dispatch({
    type: actions.LOTES_IMPRESION_LOAD_REQUESTED,
    payload,
  })
}
